export default __webpack_public_path__ + "static/media/19.da37a534.jpg";